import * as PropTypes from 'prop-types';

import {ArchiveRecord} from 'archive/ArchiveConstants';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import {Institution} from 'institutions/InstitutionConstants';
import {Organization} from 'orgs/OrganizationConstants';

export enum ProclaimedStatus {
  ACADEMIC = 'ACADEMIC',
  NONPROFIT = 'NONPROFIT',
  COMMERCIAL = 'COMMERCIAL',
}

export const USER_SHAPE_PROPS = {
  id: PropTypes.string.isRequired,
  handle: PropTypes.string.isRequired,
  avatar_url: PropTypes.string.isRequired,
};

export const USER_SHAPE = PropTypes.shape(USER_SHAPE_PROPS);

export const BULK_USER_IMPORT_FILE_NAME = 'bulk_user_import.csv';

const UserConstants = {
  PROCLAIMED_ACADEMIC: 'ACADEMIC',
  PROCLAIMED_NONPROFIT: 'NONPROFIT',
  PROCLAIMED_COMMERCIAL: 'COMMERCIAL',
  STATUS_GOLD: 'gold',
  GOLD_MIN_REFERRALS: 10,
  GOLD_SPACE: 15 * 1024 * 1024 * 1024,
  // TODO: This is a misnomer and should be cleaned up. USER_SHAPE is just a dict of the fields, not
  // an actual shape proptype as our usual convention would imply.
  USER_SHAPE: USER_SHAPE_PROPS,
  LANGUAGE_PREFERENCE_KEY: 'languageTag',
  SPREADSHEET_IMPORT_LANGUAGE_TAG: 'SPREADSHEET_IMPORT_LANGUAGE_TAG',
};

export interface Entity {
  id: string;
  handle: string;
  initials?: string;
  name?: string;
  type?: string;
}

export const ENTITY_SHAPE = PropTypes.shape({
  id: PropTypes.string.isRequired,
  handle: PropTypes.string.isRequired,
  initials: PropTypes.string,
  name: PropTypes.string,
  type: PropTypes.string,
});

export default UserConstants;

export type EntityType =
  | ModelTypeConstants.USER
  | ModelTypeConstants.ORGANIZATION
  | ModelTypeConstants.BENCHLING_APP;

export function isUser(owner: {type?: EntityType}): owner is User {
  return owner.type === ModelTypeConstants.USER;
}
export function isOrganization(owner: {type?: EntityType}): owner is Organization {
  return owner.type === ModelTypeConstants.ORGANIZATION;
}

export interface EntitySummary {
  id: string;
  avatar_url: string;
  handle: string;
  institution?: Institution | null;
  joinedOn: string;
  name: string;
  type?: EntityType;
  url_identifier: string;
}

export interface BaseEntity extends EntitySummary {}

// Based on USER_SHAPE
export interface UserSummary {
  id: string;
  handle: string;
  avatar_url: string;
}

export interface User extends BaseEntity {
  academic: boolean;
  admin?: boolean;
  avatar_url: string;
  email: string;
  institution: Institution | null;
  isTenantAdmin: boolean;
  joinedOn: string;
  proclaimed: ProclaimedStatus | null;
  status: 'gold' | null;
  suspended: boolean;
  type: ModelTypeConstants.USER;
  url_identifier: string;
}

export interface UserMetadata {
  company: string | null;
  initiallyOptedIntoMarketing: boolean | null;
  isEnterpriseLead: boolean;
  lab: string | null;
  phoneNumber: string | null;
  scientificField: string | null;
  teamName: string | null;
  teamSize: string | null;
  title: string | null;
}

export interface UpdateUserMetadataPayload {
  academicRole?: string | null;
  company?: string | null;
  industry?: string | null;
  institutionId?: string | null;
  phoneNumber?: string | null;
  scientificField?: string | null;
  teamName?: string | null;
  title?: string | null;
}

export interface UserReferralModalsResponse {
  showInviteModal: boolean;
}

export interface BenchlingApp {
  archiveRecord: ArchiveRecord | null;
  id: string;
  avatar_url: string;
  handle: string;
  institution?: Institution | null;
  joinedOn: string;
  name: string;
  url_identifier: string;
  type: ModelTypeConstants.BENCHLING_APP;
}
